import { Link } from "react-router-dom";
import { CONTACT } from "@/config/contact";

export default function TermsPage() {
  return (
    <div className="pt-28 lg:pt-44 pb-16" data-testid="terms-page">
      <section className="max-w-3xl mx-auto px-6">
        <p className="font-accent text-xl text-sunset mb-1">the details</p>
        <h1 className="font-display text-4xl sm:text-5xl tracking-tight mb-4">Terms &amp; Conditions</h1>
        <p className="text-charcoal/50 text-xs mb-8">Please review with a professional before publishing. Last updated: 2026.</p>

        <div className="space-y-6 text-charcoal/75 leading-relaxed text-sm">
          <p>These terms cover your use of this website and any orders you place with {CONTACT.businessName}. By using the site or ordering, you agree to them.</p>

          <div>
            <h2 className="font-display text-lg text-black mb-2">Products &amp; pricing</h2>
            <p>I try to describe and price every product accurately. Prices are in GBP and include VAT where applicable. Now and then an error slips through — if that happens I'll let you know before your order is processed.</p>
          </div>

          <div>
            <h2 className="font-display text-lg text-black mb-2">Orders &amp; payment</h2>
            <p>Payments are handled securely by Stripe. Your order is confirmed once payment is complete. I may cancel and refund an order if a product is unavailable or an obvious pricing error has occurred.</p>
          </div>

          <div>
            <h2 className="font-display text-lg text-black mb-2">Delivery &amp; returns</h2>
            <p>Delivery options and timings are on the <Link to="/delivery" className="text-olive underline underline-offset-2">Delivery</Link> page. Returns are covered on the <Link to="/returns" className="text-olive underline underline-offset-2">Returns</Link> page. Nothing here affects your statutory rights.</p>
          </div>

          <div>
            <h2 className="font-display text-lg text-black mb-2">Using the site</h2>
            <p>All content, images and branding on this site belong to {CONTACT.businessName} unless stated otherwise, and can't be copied or reused without permission. Please use the site lawfully and respectfully.</p>
          </div>

          <div>
            <h2 className="font-display text-lg text-black mb-2">Liability</h2>
            <p>I always do my best, but I can't accept responsibility for how products are used once they leave me. Always follow product instructions and patch-test where advised. Nothing in these terms limits liability where the law doesn't allow it.</p>
          </div>

          <div>
            <h2 className="font-display text-lg text-black mb-2">Governing law</h2>
            <p>These terms are governed by the laws of England and Wales.</p>
          </div>

          <div>
            <h2 className="font-display text-lg text-black mb-2">Contact</h2>
            <p>Questions? Email <a href={`mailto:${CONTACT.email}`} className="text-olive underline underline-offset-2">{CONTACT.email}</a>.</p>
          </div>
        </div>
      </section>
    </div>
  );
}
